module.exports = __webpack_public_path__ + "static/media/teacher-02.64ea5a80.png";